import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./kiosk_payment_terminal_model.js";
//#region src/kiosk_payment_terminal_model_helper.ts
var kiosk_payment_terminal_model_helper_exports = /* @__PURE__ */ __exportAll({
	iconUrl: () => iconUrl,
	name: () => name
});
function name(paymentTerminalModel) {
	switch (paymentTerminalModel) {
		case 0: return "No Payment Terminal";
		case 1: return "Ingenico iPP 320";
		case 2: return "Ingenico iPP 350";
		case 3: return "Ingenico iSMP4";
		case 4: return "Ingenico Lane/3000";
		case 5: return "Ingenico iUC285";
		case 6: return "Ingenico Link/2500";
		case 9: return "Ingenico Link/2500i";
		case 7: return "Ingenico Lane/3600";
		case 8: return "Ingenico Lane/5000";
		case 10: return "Ingenico Lane/8000";
		case 60: return "Ingenico AXIUM RX5000";
		case 61: return "Ingenico AXIUM RX7000";
		case 62: return "Ingenico AXIUM EX8000";
		case 63: return "Ingenico AXIUM DX8000";
		case 11: return "Square Reader S8";
		case 12: return "Ingenico Self/4000";
		case 20: return "Verifone mx915";
		case 23: return "Verifone CM5";
		case 22: return "Verifone e285";
		case 21: return "Verifone P400";
		case 24: return "Verifone P630";
		case 31: return "BBPOS WisePOS E";
		case 51: return "PAX A35";
		case 100: return "Unknown";
	}
}
function iconUrl(paymentTerminalModel) {
	switch (paymentTerminalModel) {
		case 31: return "https://static.bureau.getbite.com/images/status-payment-bbpos-wisepos-e@2x.png";
		case 1:
		case 2: return "https://static.bureau.getbite.com/images/status-payment-ingenico-ipp-320@2x.png";
		case 3: return "https://static.bureau.getbite.com/images/status-payment-ingenico-ismp4@2x.png";
		case 5: return "https://static.bureau.getbite.com/images/status-payment-ingenico-iuc-285@2x.png";
		case 4: return "https://static.bureau.getbite.com/images/status-payment-ingenico-lane-3000@2x.png";
		case 7: return "https://static.bureau.getbite.com/images/status-payment-ingenico-lane-3600@2x.png";
		case 8: return "https://static.bureau.getbite.com/images/status-payment-ingenico-lane-5000@2x.png";
		case 10: return "https://static.bureau.getbite.com/images/status-payment-ingenico-lane-8000@2x.png";
		case 12: return "https://static.bureau.getbite.com/images/status-payment-ingenico-self-4000@2x.png";
		case 6:
		case 9: return "https://static.bureau.getbite.com/images/status-payment-ingenico-link-2500@2x.png";
		case 60: return "https://static.bureau.getbite.com/images/status-payment-ingenico-rx5000@2x.png";
		case 61: return "https://static.bureau.getbite.com/images/status-payment-ingenico-rx7000@2x.png";
		case 62: return "https://static.bureau.getbite.com/images/status-payment-ingenico-ex8000@2x.png";
		case 63: return "https://static.bureau.getbite.com/images/status-payment-ingenico-dx8000@2x.png";
		case 11: return "https://static.bureau.getbite.com/images/status-payment-square-reader-s8@2x.png";
		case 20: return "https://static.bureau.getbite.com/images/status-payment-verifone-mx-915@2x.png";
		case 22: return "https://static.bureau.getbite.com/images/status-payment-verifone-e285@2x.png";
		case 21: return "https://static.bureau.getbite.com/images/status-payment-verifone-p400@2x.png";
		case 24: return "https://static.bureau.getbite.com/images/status-payment-verifone-p630@2x.png";
		case 23: return "https://static.bureau.getbite.com/images/status-payment-verifone-cm5@2x.png";
		case 51: return "https://static.bureau.getbite.com/images/status-payment-pax-a35@2x.png";
		case 0:
		case 100: return null;
	}
}
//#endregion
export { iconUrl, kiosk_payment_terminal_model_helper_exports, name };

//# sourceMappingURL=kiosk_payment_terminal_model_helper.js.map